import { PlayCircle, Award, TrendingUp, FileText } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const PLACEHOLDERS = [
  { icon: PlayCircle, type: "VIDEO TESTIMONIAL" },
  { icon: Award, type: "FUNDED ACCOUNT MILESTONE" },
  { icon: TrendingUp, type: "EXECUTION BREAKTHROUGH" },
  { icon: FileText, type: "P.E.E. OS CASE STUDY" },
];

export default function Results() {
  return (
    <section id="results" data-testid="results-section" className="border-t border-line bg-[#070809] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="10 — Results"
          testid="results-heading"
          title={
            <>
              Real Executors.
              <br />
              Real <span className="glow-text-neon text-neon">progress.</span>
            </>
          }
          description="Video testimonials, funded milestones, student progress, and P.E.E. OS case studies — published only when verified and shared with member consent."
        />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {PLACEHOLDERS.map((p, i) => (
            <Reveal key={p.type} delay={0.07 * i} className="h-full">
              <div
                data-testid={`results-placeholder-${i}`}
                className="flex h-full min-h-[240px] flex-col rounded-lg border border-dashed border-line bg-charcoal/50 p-7"
              >
                <div className="flex items-center justify-between">
                  <p.icon size={20} className="text-dim" />
                  <span className="font-mono text-[9px] uppercase tracking-[0.22em] text-dim">
                    {p.type}
                  </span>
                </div>
                <div className="flex flex-1 flex-col items-center justify-center py-8 text-center">
                  <span className="font-display text-lg font-bold uppercase tracking-tight text-white/35">
                    Real Executor Story
                  </span>
                  <span className="mt-3 rounded border border-neon/40 bg-neon/5 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-neon">
                    Coming Soon
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 max-w-2xl font-mono text-[10px] uppercase leading-relaxed tracking-[0.18em] text-dim">
            No fabricated screenshots. No invented numbers. Stories appear here
            only when real Executors share them.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
